import { MetaApiResponse } from '@/utils/types/CommonApiResponse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getBusinessAuditTrails } from './api';

export function useGetBusinessAuditTrails(
  params: any,
  options?: UseQueryOptions<{ data: any[]; meta: MetaApiResponse }, Error>
) {
  return useQuery<{ data: any[]; meta: MetaApiResponse }>({
    queryKey: ['business_audit_trails', params],
    queryFn: () => getBusinessAuditTrails(params),
    ...options
  });
}
